import React from 'react';
import { Tag } from 'antd';
import { version } from '../../package.json';


const Footer = ({sidebarOpen}) => {
	return (
		<div
			id="app-footer"
			className={`fixed bottom-0 w-full bg-primaryBlue font-museoSansBold flex items-center justify-center text-base px-20 py-1 ${sidebarOpen? 'pl-60' : ''} md:px-20 sm:px-10 transition-padding ease-in-out duration-200 z-90!`}
		>
			<span className="text-white text-sm">v{version}&nbsp;&nbsp;</span>
			<p className="text-white sm:text-sm">Powered by</p>
			<img className="h-10" src="/images/polybee_logo_white.svg" alt="Polybee Logo"/>
		</div>
	)
}

export default Footer;
